import { createStore } from 'vuex'
import Axios from './axios';
import createPersistedState from "vuex-persistedstate";

export default createStore({
    state() {
        return {
            wishlists: undefined,
            addedDocuments: [],
            pageUrls: undefined
        }
    },
    plugins: [createPersistedState({ storage: window.sessionStorage })],
    mutations: {
        SET_PAGEURLS(state, value) {
            state.pageUrls = value;
        },
        SET_WISHLISTS(state, value) {
            state.wishlists = value;
        },
        SET_ADDEDDOCUMENTS(state, value) {
            state.addedDocuments = value;
        },
        ADD_DOCUMENT(state, params) {
            state.addedDocuments.push(params.documentId);
            state.wishlists.find(x => x.id === params.listId).documents.push(params.documentId);
        },
        REMOVE_DOCUMENT(state, params) {
            let index = state.addedDocuments.indexOf(params.documentId);
            if (index > -1) {
                state.addedDocuments.splice(index, 1);
            }
            let wishlist = state.wishlists.find(x => x.id === params.listId);
            let listIndex = wishlist.documents.indexOf(params.documentId);
            if (listIndex > -1) {
                wishlist.documents.splice(listIndex, 1);
            }
        },
        DELETE_WISHLIST(state, value) {
            let index = state.wishlists.indexOf(value);
            if (index > -1) {
                state.wishlists.splice(index, 1);
            }
        }
    },
    actions: {
        getPageUrls: ({ commit, dispatch, state, getters }) => {
            return new Promise(resolve => {
                Axios
                    .get('/page/page-urls')
                    .then(result => {
                        commit('SET_PAGEURLS', result);
                        resolve();
                    });
            });
        },
        getWishlists: ({ commit, dispatch, state, getters }) => {
            return new Promise(resolve => {
                Axios
                    .get('/MyProfile/FavoriteListOverview')
                    .then(result => {
                        commit('SET_WISHLISTS', result.lists);
                        let addedDocuments = [];
                        for (let list of result.lists) {
                            addedDocuments = [...addedDocuments, ...list.documents];
                        }
                        commit('SET_ADDEDDOCUMENTS', addedDocuments);
                        resolve();
                    });
            });
        },
        getSingleWishlist: ({ commit, dispatch, state, getters }, id) => {
            return new Promise(resolve => {
                Axios
                    .get('/MyProfile/FavoriteList?listId=' + id)
                    .then(result => {
                        resolve(result);
                    }).catch((error) => {
                        if (error.response) {
                            resolve(error.response);
                            // Request made and server responded
                            // console.log("response.data = ",error.response.data);
                            // console.log("response.status = ",error.response.status);
                            // console.log("response.headers = ",error.response.headers);
                        } else if (error.request) {
                            // The request was made but no response was received
                            // console.log("error.request = ",error.request);
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            // console.log('Error', error.message);
                        }
                    });
            });
        },
        saveWishlist: ({ commit, dispatch, state, getters }, name) => {
            return new Promise(resolve => {
                Axios
                    .post('/MyProfile/FavoriteList?name=' + name)
                    .then(result => {
                        resolve(result);
                    });
            });
        },
        updateWishlist: ({ commit, dispatch, state, getters }, params) => {
            return new Promise(resolve => {
                Axios
                    .put('/MyProfile/FavoriteList?listId=' + params.listId + '&name=' + params.name)
                    .then(result => {
                        resolve(result);
                    });
            });
        },
        deleteWishlist: ({ commit, dispatch, state, getters }, listId) => {
            return new Promise(resolve => {
                Axios
                    .delete('/MyProfile/FavoriteList?listId=' + listId)
                    .then(result => {
                        commit('DELETE_WISHLIST', listId);
                        resolve(result);
                    });
            });
        },
        addDocumentToWishlist: ({ commit, dispatch, state, getters }, params) => {
            return new Promise(resolve => {
                Axios
                    .post('/MyProfile/FavoriteListDocument?listId=' + params.listId + '&documentId=' + params.documentId)
                    .then(result => {
                        commit('ADD_DOCUMENT', params);
                        resolve(result);
                    });
            });
        },
        deleteDocumentFromWishlist: ({ commit, dispatch, state, getters }, params) => {
            return new Promise(resolve => {
                Axios
                    .delete('/MyProfile/FavoriteListDocument?listId=' + params.listId + '&documentId=' + params.documentId)
                    .then(result => {
                        commit('REMOVE_DOCUMENT', params);
                        resolve(result);
                    });
            });
        },
        getPublicWishlist: ({ commit, dispatch, state, getters }, id) => {
            return new Promise(resolve => {
                Axios
                    .get('/MyProfile/FavoriteList?publicListId=' + id)
                    .then(result => {
                        resolve(result);
                    }).catch((error) => {
                        if (error.response) {
                            resolve(error.response);
                            // Request made and server responded
                            // console.log("response.data = ",error.response.data);
                            // console.log("response.status = ",error.response.status);
                            // console.log("response.headers = ",error.response.headers);
                        } else if (error.request) {
                            // The request was made but no response was received
                            // console.log("error.request = ",error.request);
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            // console.log('Error', error.message);
                        }
                    });
            });
        },
        shareWishlistEmail: ({ commit, dispatch, state, getters }, emailViewModel) => {
            return new Promise(resolve => {
                Axios
                    .post('/MyProfile/FavoriteList/PublicEmail', emailViewModel, {})
                    .then(result => {
                        resolve(result);
                    }).catch((error) => {
                        if (error.response) {
                            resolve(error.response);
                            // Request made and server responded
                            // console.log("response.data = ",error.response.data);
                            // console.log("response.status = ",error.response.status);
                            // console.log("response.headers = ",error.response.headers);
                        } else if (error.request) {
                            // The request was made but no response was received
                            // console.log("error.request = ",error.request);
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            // console.log('Error', error.message);
                        }
                    });
            });
        },
    }
})